import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import 'nprogress/nprogress.css';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { Auth0Provider } from '@auth0/auth0-react';
import { SubscriptionProvider } from 'src/contexts/SubscriptionContext';
import { AdminProvider } from 'src/contexts/AdminContext';
import { DisplayCurrencyProvider } from 'src/contexts/DisplayCurrencyContext';
import { PrivacyModeProvider } from 'src/contexts/PrivacyModeContext';
import { initializeErrorTracking } from './utils/errorTracking';
import { App } from './App';

initializeErrorTracking();

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN || "auth.portfoliomatic.ca"}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || "VDIt3cnRWBen4otOe8PaN4mZxgkwaxPH"}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE || "https://portfoliomatic/api"
    }}
    onRedirectCallback={(appState) => {
      if (appState?.returnTo) {
        sessionStorage.setItem('returnTo', appState.returnTo);
      }
    }}
    cacheLocation="localstorage"
  >
    <HelmetProvider>
      <SidebarProvider>
        <SubscriptionProvider>
          <AdminProvider>
            <DisplayCurrencyProvider>
              <PrivacyModeProvider>
                <BrowserRouter
                  future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true
                  }}>
                  <App />
                </BrowserRouter>
              </PrivacyModeProvider>
            </DisplayCurrencyProvider>
          </AdminProvider>
        </SubscriptionProvider>
      </SidebarProvider>
    </HelmetProvider>
  </Auth0Provider>
);
serviceWorker.unregister();
